// ##############################
// // // LoginPage view styles
// #############################

import { container, cardTitle } from '../../../assets/jss/material-dashboard-pro-react';

const loginPageStyle = theme => ({
  container: {
    ...container,
    zIndex                        : '4',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '100px',
    },
  },
  cardTitle: {
    ...cardTitle,
    color     : '#FFFFFF',
    fontWeight: '500',
    fontSize  : '19px',
  },
  textCenter: {
    textAlign: 'center',
  },
  justifyContentCenter: {
    justifyContent: 'flex-end',
    paddingBottom : '10px',
    paddingTop    : 0,
  },
  inputAdornmentIcon: {
    color: '#555',
  },
  cardHidden: {
    opacity  : '0',
    transform: 'translate3d(0, -60px, 0)',
  },
  cardHeader: {
    borderRadius: '10px !important',
    margin      : '0 auto !important',
    width       : '100%',
    marginTop   : '-20px !important',
    maxWidth    : '250px',
    paddingTop  : '0 !important',
  },
});

export default loginPageStyle;
